const AUTH_TELEMETRY_PREFIX = "[auth-telemetry]"

export type AuthTelemetryReason = "token_expired" | "refresh_failed" | "unauthorized_response" | "manual_logout"

type AuthTelemetryPayload = {
  reason: AuthTelemetryReason
  message?: string
  source?: string
  details?: Record<string, unknown>
  at: string
}

export const trackAuthTelemetry = (payload: Omit<AuthTelemetryPayload, "at">): void => {
  const event: AuthTelemetryPayload = {
    ...payload,
    at: new Date().toISOString(),
  }

  try {
    console.info(AUTH_TELEMETRY_PREFIX, event)
  } catch {
    // Ignore console serialization errors to keep auth flow safe.
  }
}
